import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
//import { firebase } from '../firebase';
//import * as routes from '../constants/routes';
const withAuthorization = (condition) => (Component) => {
  class WithAuthorization extends React.Component {
    componentDidMount() {
     
     
    }


    render() {
      return this.props.authUser ? <Component authUser={this.props.authUser} /> : null;
    }
  }

  const mapStateToProps = (state) => ({
    authUser: state.sessionState.authUser,
  });

  return compose(
    withRouter,
    connect(mapStateToProps),
  )(WithAuthorization);
}

export default withAuthorization;


// WEBPACK FOOTER //
// ./src/Components/withAuthorization.js